export function filterDemandPlanningTableRecordsBySearch(records, searchTerm) {
    const rows = Array.isArray(records) ? records : [];
    const query = String(searchTerm || "").trim().toLowerCase();
    if (!query) return rows;

    return rows.filter((row) => {
        const haystack = Object.values(row)
            .filter((value) => value !== null && value !== undefined)
            .join(" ")
            .toLowerCase();
        return haystack.includes(query);
    });
}
